var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12.308,
    viewBox: "0 0 10 12.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash_1_",
    "data-name": "trash (1)",
    transform: "translate(-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M57.038,1.538H54.923V1.154A1.155,1.155,0,0,0,53.769,0H52.231a1.155,1.155,0,0,0-1.154,1.154v.385H48.962A.963.963,0,0,0,48,2.5V3.846a.385.385,0,0,0,.385.385h.21l.332,6.978a1.152,1.152,0,0,0,1.153,1.1H55.92a1.152,1.152,0,0,0,1.153-1.1l.332-6.978h.21A.385.385,0,0,0,58,3.846V2.5A.963.963,0,0,0,57.038,1.538Zm-5.192-.385a.385.385,0,0,1,.385-.385h1.538a.385.385,0,0,1,.385.385v.385H51.846ZM48.769,2.5a.193.193,0,0,1,.192-.192h8.077a.193.193,0,0,1,.192.192v.962H48.769ZM56.3,11.172a.384.384,0,0,1-.384.366H50.08a.384.384,0,0,1-.384-.366l-.331-6.941h7.27Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M240.385,213.769a.385.385,0,0,0,.385-.385v-5a.385.385,0,0,0-.769,0v5A.385.385,0,0,0,240.385,213.769Z",
    transform: "translate(-187.385 -203)",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M320.385,213.769a.385.385,0,0,0,.385-.385v-5a.385.385,0,1,0-.769,0v5A.385.385,0,0,0,320.385,213.769Z",
    transform: "translate(-265.462 -203)",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M160.385,213.769a.385.385,0,0,0,.385-.385v-5a.385.385,0,0,0-.769,0v5A.385.385,0,0,0,160.385,213.769Z",
    transform: "translate(-109.308 -203)",
    fill: "#767676"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e1227795ee03aefb73c8f88e7d400598.svg";
export { ForwardRef as ReactComponent };